
import React from "react";
import { MessageCircle, X } from "lucide-react";

export default function AIChatButton({ isOpen, onClick }) {
  return (
    <button
      type="button"
      className="ai-assistant-toggle"
      onClick={onClick}
      aria-label={isOpen ? "Close AI assistant" : "Open AI assistant"}
      aria-expanded={isOpen}
    >
      {isOpen ? <X size={24} /> : <MessageCircle size={24} />}
      <span>{isOpen ? "Close" : "AI Assistant"}</span>
    </button>
  );
}
